import { useState } from "react";
import PopupGlobel from "../PopModal/PopupGlobel";
import { useNavigate } from "react-router-dom";
import apiService from "../Services/apiService"; 
import {useNotification} from "../notifications/useNotification";
import {useLoading} from "../Context/LoadingContext";
import NotificationBell from  "../notifications/NotificationBell";
type Props = {
  setIsRegisteredAccount: (data: boolean) => void;
};
const PopSendEmail = ({ setIsRegisteredAccount }: Props) => {
    const { addNotification }= useNotification();
    const {
  showLoader,
  hideLoader,
  isSaudiMobile,
  isEmail
} = useLoading();
  const navigate = useNavigate(); 
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [errName, setErrName] = useState("");
  const [errMobile, setErrMobile] = useState("");
  const [errEmail, setErrEmail] = useState("");
  const handelSendEmail = async () => {
    try { 
      showLoader();
      const result = await apiService.fetchData("api/SendEmailToCustomerService", {
        name: name,
        mobile: mobile,
        email: email,
        desc: desc,
      });
      if (result.isOk) {
         addNotification({
      title: "نجاح",
      message: "نجاح إرسال البريد الإلكتروني",
      type: "success"
    });
      } else    addNotification({
      title: "فشل",
      message: result.errAr,
      type: "error"
    });
          hideLoader();
      return result;
    } catch (error) {
     addNotification({
      title: "فشل",
      message:String( error),
      type: "error"
    });
       hideLoader();
      return null;
    }
  };
 
  const validateForm = () => {
   
    let isValidate = true;
    if (name.trim() === "") {
      isValidate = false;
      setErrName("إدخل الاسم");
    } else {
      setErrName("");
    }
     if (mobile.trim() === "") {
      isValidate = false;
      setErrMobile("إدخل رقم الجوال  ");
    } else {
      if (isSaudiMobile(mobile.trim()) !== true) {
        isValidate = false;
        setErrMobile("صيغة رقم الجوال غير صحيح");
      } else {
        setErrMobile("");
      } 
    }
      if (email.trim() === "") {
      isValidate = false;
      setErrEmail("إدخل البريد الإلكتروني  ");
    } else {
      if (isEmail(email.trim()) !== true) {
        isValidate = false;
        setErrEmail("صيغة الايميل غير صحيح");
      } else {
        setErrEmail("");
      } 
    }
    
    return isValidate;
  };
  return (
    <>
    <NotificationBell />
      <PopupGlobel
        approveAction={() => {
          if (validateForm()) {
            handelSendEmail();
          } else {
            addNotification({
      title: "فشل",
      message: "عفوا,,راجع مدخلات الحقول",
      type: "error"
    });
          }
        }}
        cancelAction={() => {
          setIsRegisteredAccount(false);
        }}
        btnApproveTitle="إرسال البريد"
        btnCancelTitle="الغاء"
        title="تاكيد إرسال البريد الإلكتروني"
        popupType={1}
        size="4xl"
        btnIcon="send"
      >
        {/* Form Elements */}
        <form className="space-y-6" id="officialCommunicationForm">
          {/* Row 1: Full Name & Mobile Number */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Full Name Field */}
            <div className="flex flex-col gap-2">
              <label
                className="font-label-md text-label-md font-bold text-deep-navy flex items-center justify-between"
                htmlFor="recipientName"
              >
                <span className="flex items-center gap-1.5">
                  <span className="material-symbols-outlined text-lg text-primary">
                    person
                  </span>
                  <span>اسم المستخدم  
                      </span>
                      {errName !== "" ? (
                  <span
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      fontSize: "12px",
                    }}
                  >
                    {errName}
                  </span>
                ) : (
                  ""
                )}
                </span>
                <span className="font-label-sm text-label-sm text-error font-medium">
                  * مطلوب
                </span>
              </label>
              <div className="relative flex items-center">
                <div className="absolute right-4 text-outline pointer-events-none flex items-center">
                  <span className="material-symbols-outlined text-xl">
                    badge
                  </span>
                </div>
                <input
                  className="w-full h-14 pr-12 pl-4 rounded-xl bg-surface-container-lowest text-on-surface font-body-md text-body-md placeholder:text-outline-variant shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:bg-surface-bright transition-all"
                  id="recipientName"
                  placeholder="مثال:ادريس الهلالي"
                  style={{ border: "2px solid #c0c7d1" }}
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div> 
            </div>
            {/* Mobile Phone Field */}
            <div className="flex flex-col gap-2">
              <label
                className="font-label-md text-label-md font-bold text-deep-navy flex items-center justify-between"
                htmlFor="recipientMobile"
              >
                <span className="flex items-center gap-1.5">
                  <span className="material-symbols-outlined text-lg text-primary">
                    smartphone
                  </span>
                  <span>رقم الجوال المعتمد للدخول </span>
                  {errMobile !== "" ? (
                  <span
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      fontSize: "12px",
                    }}
                  >
                    {errMobile}
                  </span>
                ) : (
                  ""
                )}
                </span>
                <span className="font-label-sm text-label-sm text-error font-medium">
                  * مطلوب
                </span>
              </label>
              <div className="relative flex items-center" dir="ltr">
                {/* Country Prefix Badge */}
                <div className="absolute left-0 top-0 bottom-0 px-4 bg-surface-container flex items-center gap-1.5 rounded-l-[10px] text-deep-navy font-bold font-label-md text-label-md">
                  <span className="text-base">🇸🇦</span>
                  <span>+966</span>
                </div>
                <input
                  className="w-full h-14 pl-28 pr-12 rounded-xl bg-surface-container-lowest text-on-surface font-body-md text-body-md placeholder:text-outline-variant shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:bg-surface-bright transition-all text-left"
                  id="recipientMobile"
                  placeholder="05XXXXXXXX"
                  style={{ border: "2px solid #c0c7d1" }}
                  type="tel"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                />
                <div className="absolute right-4 text-outline pointer-events-none flex items-center">
                  <span className="material-symbols-outlined text-xl">
                    phone_iphone
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* Email Address Field */}
          <div className="flex flex-col gap-2">
            <label
              className="font-label-md text-label-md font-bold text-deep-navy flex items-center justify-between"
              htmlFor="recipientEmail"
            >
              <span className="flex items-center gap-1.5">
                <span className="material-symbols-outlined text-lg text-primary">
                  alternate_email
                </span>
                <span>البريد الإلكتروني للمستلم</span>
                {errEmail !== "" ? (
                  <span
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      fontSize: "12px",
                    }}
                  >
                    {errEmail}
                  </span>
                ) : (
                  ""
                )}
              </span>
              <span className="font-label-sm text-label-sm text-error font-medium">
                * مطلوب
              </span>
            </label>
            <div className="relative flex items-center" dir="ltr">
              <div className="absolute right-4 text-outline pointer-events-none flex items-center">
                <span className="material-symbols-outlined text-xl">mail</span>
              </div>
              <input
                className="w-full h-14 pr-12 pl-4 rounded-xl bg-surface-container-lowest text-on-surface font-body-md text-body-md placeholder:text-outline-variant shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:bg-surface-bright transition-all text-left"
                id="recipientEmail"
                style={{ border: "2px solid #c0c7d1" }}
                type="email"
                placeholder="username@gmail.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>
          {/* Subject Line Specific Input */}
          <div className="flex flex-col gap-2">
            <label
              className="font-label-md text-label-md font-bold text-deep-navy flex items-center justify-between"
              htmlFor="customSubject"
            >
              <span className="flex items-center gap-1.5">
                <span className="material-symbols-outlined text-lg text-primary">
                  subject
                </span>
                <span> ملاحظات اضافية </span>
              </span>
            </label>
            <div className="relative flex items-center">
              <div className="absolute right-4 text-outline pointer-events-none flex items-center">
                <span className="material-symbols-outlined text-xl">
                  edit_note
                </span>
              </div>
              <input
                className="w-full h-14 pr-12 pl-4 rounded-xl bg-surface-container-lowest text-on-surface font-body-md text-body-md placeholder:text-outline-variant shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:bg-surface-bright transition-all"
                id="customSubject"
                placeholder="اي ملاحظات اخرى"
                style={{ border: "2px solid #c0c7d1" }}
                type="text"
                value={desc}
                onChange={(e) => setDesc(e.target.value)}
              />
            </div>
          </div>
        </form>
      </PopupGlobel>
    </>
  );
};
export default PopSendEmail;

 